import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CustomExplainedTerm } from '../format-data-for-content-tile/types';
import { MetadataObject } from '../../../../../types/__codegen__/sanity/graphql';

type GetMetadataParams = {
  metadataObject?: MetadataObject | null;
  summary?: CustomExplainedTerm['summary'];
  slogan?: CustomExplainedTerm['slogan'];
};

const getMetadata = ({ metadataObject, summary, slogan }: GetMetadataParams) => {
  const metaTitle = metadataObject?.name ?? portableTextToPlain(slogan);
  const metaDescription = metadataObject?.descriptionRaw ?? summary;
  return { metaDescription: portableTextToPlain(metaDescription), metaTitle };
};

export default getMetadata;
